/* eslint-disable no-debugger */
/* eslint-disable prefer-const */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable object-shorthand */
/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable no-var */
/* eslint-disable no-alert */
/* eslint-disable no-console */

export default function initOpenClose(): boolean {
    if (window === undefined || window.jQuery === undefined) {
        return false;
    }
    (function ($) {

        function OpenClose(this: any, options: any) {
            this.options = $.extend(
                {
                    addClassBeforeAnimation: true,
                    hideOnClickOutside: false,
                    activeClass: 'active',
                    opener: '.opener',
                    slider: '.slide',
                    animSpeed: 400,
                    effect: 'fade',
                    event: 'click',
                    showActiveOnly: false,
                    openCloseGroupSelector:''
                },
                options
            );
            this.init();
        }
        OpenClose.prototype = {
            init() {
                if (this.options.holder) {
                    this.findElements();
                    this.attachEvents();
                    this.makeCallback('onInit', this);
                }
            },
            findElements() {
                this.holder = $(this.options.holder);
                this.opener = this.holder.find(this.options.opener);
                this.slider = this.holder.find(this.options.slider);
            },
            attachEvents() {
                // add handler
                const self = this;
                this.eventHandler = function (e: { preventDefault: () => void; }) {
                    e.preventDefault();
                    if (self.slider.hasClass(slideHiddenClass)) {
                        self.showSlide();
                    } else {
                        self.hideSlide();
                    }
                };
                self.opener.on(self.options.event, this.eventHandler);

                // hover mode handler
                if (self.options.event === 'hover') {
                    self.opener.on('mouseenter', function () {
                        if (!self.holder.hasClass(self.options.activeClass)) {
                            self.showSlide();
                        }
                    });
                    self.holder.on('mouseleave', function () {
                        self.hideSlide();
                    });
                }

                // outside click handler
                self.outsideClickHandler = function (e: { target: any; }) {
                    if (self.options.hideOnClickOutside) {
                        const target = $(e.target);
                        if (!target.is(self.holder) && !target.closest(self.holder).length) {
                            self.hideSlide();
                        }
                    }
                };

                // set initial styles
                if (this.holder.hasClass(this.options.activeClass)) {
                    $(document).on('click touchstart', self.outsideClickHandler);
                } else {
                    this.slider.addClass(slideHiddenClass);
                }
            },
            showSlide() {
                const self = this;
                if(self.options.showActiveOnly && self.options.openCloseGroupSelector && $(self.options.openCloseGroupSelector).length>0){
                    $(self.options.openCloseGroupSelector).each((_i: any,e: any)=>{
                        $(e).removeClass(self.options.activeClass);
                        $(e).find(self.options.slider).addClass(slideHiddenClass);
                    })
                }
                if (self.options.addClassBeforeAnimation) {
                    self.holder.addClass(self.options.activeClass);
                }
                self.slider.removeClass(slideHiddenClass);
                $(document).on('click touchstart', self.outsideClickHandler);
                
                
                self.makeCallback('animStart', true);
                getToggleEffects(self.options.effect).show({
                    box: self.slider,
                    speed: self.options.animSpeed,
                    complete() {
                        if (!self.options.addClassBeforeAnimation) {
                            self.holder.addClass(self.options.activeClass);
                        }
                        self.makeCallback('animEnd', true);
                    },
                });
            },
            hideSlide() {
                const self = this;
                if (self.options.addClassBeforeAnimation) {
                    self.holder.removeClass(self.options.activeClass);
                }
                $(document).off('click touchstart', self.outsideClickHandler);

                self.makeCallback('animStart', false);
                getToggleEffects(self.options.effect).hide({
                    box: self.slider,
                    speed: self.options.animSpeed,
                    complete() {
                        if (!self.options.addClassBeforeAnimation) {
                            self.holder.removeClass(self.options.activeClass);
                        }
                        self.slider.addClass(slideHiddenClass);
                        self.makeCallback('animEnd', false);
                    },
                });
            },
            destroy() {
                this.slider.removeClass(slideHiddenClass).css({
                    display: '',
                });
                this.opener.off(this.options.event, this.eventHandler);
                this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
                $(document).off('click touchstart', this.outsideClickHandler);
            },
            makeCallback(name: string | number) {
                if (typeof this.options[name] === 'function') {
                    const args = Array.prototype.slice.call(arguments);
                    args.shift();
                    this.options[name].apply(this, args);
                }
            },
        };

        // add stylesheet for slide on DOMReady
        var slideHiddenClass = 'js-slide-hidden';
        (function () {
            const tabStyleSheet = $('<style type="text/css">')[0];
            let tabStyleRule = `.${slideHiddenClass}`;
            tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
            if ((tabStyleSheet as any).stylesheet) {
                (tabStyleSheet as any).styleSheet.cssText = tabStyleRule;
            } else {
                tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
            }
            $('head').append(tabStyleSheet);
        })();
        var getToggleEffects = (effect: string) => {
            switch (effect) {
                case 'slide':
                    return toggleEffects.slide;
                case 'fade':
                    return toggleEffects.fade;
                case 'none':
                    return toggleEffects.none;
                default:
                    return toggleEffects.none;
            }
        }
        // animation effects
        var toggleEffects = {
            slide: {
                show(o: { box: { stop: (arg0: boolean) => { (): any; new(): any; hide: { (): { (): any; new(): any; slideDown: { (arg0: any, arg1: any): void; new(): any; }; }; new(): any; }; }; }; speed: any; complete: any; }) {
                    o.box
                        .stop(true)
                        .hide()
                        .slideDown(o.speed, o.complete);
                },
                hide(o: { box: { stop: (arg0: boolean) => { (): any; new(): any; slideUp: { (arg0: any, arg1: any): void; new(): any; }; }; }; speed: any; complete: any; }) {
                    o.box.stop(true).slideUp(o.speed, o.complete);
                },
            },
            fade: {
                show(o: { box: { stop: (arg0: boolean) => { (): any; new(): any; hide: { (): { (): any; new(): any; fadeIn: { (arg0: any, arg1: any): void; new(): any; }; }; new(): any; }; }; }; speed: any; complete: any; }) {
                    o.box
                        .stop(true)
                        .hide()
                        .fadeIn(o.speed, o.complete);
                },
                hide(o: { box: { stop: (arg0: boolean) => { (): any; new(): any; fadeOut: { (arg0: any, arg1: any): void; new(): any; }; }; }; speed: any; complete: any; }) {
                    o.box.stop(true).fadeOut(o.speed, o.complete);
                },
            },
            none: {
                show(o: { box: { hide: () => { (): any; new(): any; show: { (arg0: number, arg1: any): void; new(): any; }; }; }; complete: any; }) {
                    o.box.hide().show(0, o.complete);
                },
                hide(o: { box: { hide: (arg0: number, arg1: any) => void; }; complete: any; }) {
                    o.box.hide(0, o.complete);
                },
            },
        };

        // jQuery plugin interface
        $.fn.openClose = function (opt: any) {
            const args = Array.prototype.slice.call(arguments);
            const method = args[0];

            return this.each((i: number, e: any) => {
                const $holder = window.jQuery(e);
                const instance = $holder.data('OpenClose');

                if (typeof opt === 'object' || typeof opt === 'undefined') {
                    $holder.data(
                        'OpenClose',
                        new (OpenClose as any)(
                            $.extend(
                                {
                                    holder: e,
                                },
                                opt
                            )
                        )
                    );
                } else if (typeof method === 'string' && instance) {
                    if (typeof instance[method] === 'function') {
                        args.shift();
                        instance[method].apply(instance, args);
                    }
                }
            });
        };
    })(window.jQuery);
    const ResponsiveHelper = (function ($) {
        // init variables
        var handlers: ArrayLike<any> = [],
            prevWinWidth: number | null | undefined,
            win = $(window),
            nativeMatchMedia = false;

        // detect match media support
        if (window.matchMedia) {
            if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
                nativeMatchMedia = true;
            } else if (window.matchMedia.toString().indexOf('native') > -1) {
                nativeMatchMedia = true;
            }
        }

        // prepare resize handler
        function resizeHandler() {
            var winWidth = win.width();
            if (winWidth !== prevWinWidth) {
                prevWinWidth = winWidth;

                // loop through range groups
                $.each(handlers, function (index: any, rangeObject: any) {
                    // disable current active area if needed
                    $.each(rangeObject.data, function (property: any, item: any) {
                        if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
                            item.currentActive = false;
                            if (typeof item.disableCallback === 'function') {
                                item.disableCallback();
                            }
                        }
                    });

                    // enable areas that match current width
                    $.each(rangeObject.data, function (property: any, item: any) {
                        if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
                            // make callback
                            item.currentActive = true;
                            if (typeof item.enableCallback === 'function') {
                                item.enableCallback();
                            }
                        }
                    });
                });
            }
        }
        win.bind('load resize orientationchange', resizeHandler);

        // test range
        function matchRange(r1: string | number, r2: string | number) {
            var mediaQueryString = '';
            if ((r1 as number) > 0) {
                mediaQueryString += '(min-width: ' + r1 + 'px)';
            }
            if ((r2 as number) < Infinity) {
                mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
            }
            return matchQuery(mediaQueryString, r1 as number, r2 as number);
        }

        // media query function
        function matchQuery(query: string, r1: number, r2: number) {
            if (window.matchMedia !== undefined && nativeMatchMedia) {
                return matchMedia(query).matches;
            } else if ((window.styleMedia)) {
                return window.styleMedia.matchMedium(query);
            } else if (window.media) {
                return window.media.matchMedium(query);
            } else {
                return prevWinWidth != null && prevWinWidth >= r1 && prevWinWidth <= r2;
            }
        }

        // range parser
        function parseRange(rangeStr: string | number | symbol) {
            var rangeData = (rangeStr as string).split('..');
            var x1 = parseInt(rangeData[0], 10) || -Infinity;
            var x2 = parseInt(rangeData[1], 10) || Infinity;
            return [x1, x2].sort(function (a, b) {
                return a - b;
            });
        }

        // export public functions
        return {
            addRange: function (ranges: any) {
                // parse data and add items to collection
                var result = { data: {} };
                $.each(ranges, function (property: any, data: any) {
                    (result.data as any)[property] = {
                        range: parseRange(property),
                        enableCallback: data.on,
                        disableCallback: data.off
                    };
                });
                (handlers as any[]).push(result);

                // call resizeHandler to recalculate all events
                prevWinWidth = null;
                resizeHandler();
            }
        };
    }(window.jQuery));
    window.ResponsiveHelper = ResponsiveHelper;

    return true;
}
export function initMobileProductFilterNavOpenClose(className: any) {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.ResponsiveHelper === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const ResponsiveHelper = window.ResponsiveHelper;
        if (window.jQuery(`.as-filter-open-close${className}`).length > 0) {
            ResponsiveHelper.addRange({
                '..767': {
                    on: function () {
                        window.jQuery(`.as-filter-open-close${className}`).openClose({
                            activeClass: 'active',
                            opener: '.as-opener',
                            slider: '.as-filter-slide',
                            animSpeed: 400,
                            effect: 'slide'
                        });
                    },
                    off: function () {
                        window.jQuery(`.as-filter-open-close${className}`).openClose('destroy');
                    }
                }
            });
            clearInterval(interval);
        }
    }, 1000);
}
export function initMobileProductFilterHolderNavOpenClose() {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.ResponsiveHelper === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const ResponsiveHelper = window.ResponsiveHelper;
        if (window.jQuery(`.as-col-filters`).length > 0) {
            ResponsiveHelper.addRange({
                '..767': {
                    on: function () {
                        window.jQuery('.as-col-filters').openClose({
                            activeClass: 'active',
                            opener: '.as-opener-filters',
                            slider: '.as-filter-block-slide',
                            animSpeed: 400,
                            effect: 'slide'
                        });
                    },
                    off: function () {
                        window.jQuery('.as-col-filters').openClose('destroy');
                    }
                }
            });
            clearInterval(interval);
        }
    }, 1000);
}

export function initProductDetailSpecificationsOpenClose(id='') {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.ResponsiveHelper === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const ResponsiveHelper = window.ResponsiveHelper;
        const jQuery = window.jQuery;
        const elementId=id?`#${id}`:'';
        if (window.jQuery(`${elementId}.as-product-open-close.open-close-initialized`).length > 0) {
            jQuery(`${elementId}.as-product-open-close li`).openClose('destroy');
            jQuery(`${elementId}.as-product-open-close`).removeClass('open-close-initialized');
            jQuery(`${elementId}.as-product-open-close li:first-child`).addClass('active');
            return true;
          }
        if (window.jQuery(`${elementId}.as-product-open-close li`).length > 0) {
            ResponsiveHelper.addRange({
                '1024..': {
                    on: function () {
                        jQuery(`${elementId}.as-product-open-close li`).openClose({
                            activeClass: 'active',
                            opener: '.as-open-close-opener',
                            slider: '.as-open-close-slide',
                            animSpeed: 400,
                            effect: 'none',
                            showActiveOnly:true,
                            openCloseGroupSelector:`${elementId}.as-product-open-close li`,
                        });
                        jQuery(`${elementId}.as-product-open-close`).addClass('open-close-initialized')
                    },
                    off: function () {
                        jQuery(`${elementId}.as-product-open-close`).removeClass('open-close-initialized');
                        jQuery(`${elementId}.as-product-open-close li`).openClose('destroy');
                    }
                }
            });
            
            clearInterval(interval);
        }
    }, 1000);
}

export function initSortBoxOpenClose() {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        if (window.jQuery('.as-sort-box').length > 0) {
            window.jQuery('.as-sort-box').openClose({
                activeClass: 'active',
                opener: '.as-opener',
                slider: '.as-sort-list',
                hideOnClickOutside: true,
                animSpeed: 400,
                effect: 'none'
            });
            clearInterval(interval);
        }
    }, 1000);
}
export function initVariantSelectionOpenClose(id='') {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const elementId=id?`#${id}`:'';
        if (window.jQuery(elementId+'.as-qty-open-close').length > 0) {
            window.jQuery(elementId+'.as-qty-open-close').openClose('destroy');
            window.jQuery(elementId+'.as-qty-open-close').openClose({
                activeClass: 'active',
                opener: '.as-opener',
                slider: '.as-qty-list',
                hideOnClickOutside: true,
                animSpeed: 400,
                effect: 'none'
            });
            clearInterval(interval);
        }
    }, 100);
}
export function initMobileFooterNavOpenClose() {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.ResponsiveHelper === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const ResponsiveHelper = window.ResponsiveHelper;
        if (window.jQuery('.as-footer-nav').length > 0) {
            ResponsiveHelper.addRange({
                '..767': {
                    on() {
                        window.jQuery('.as-footer-nav').openClose({
                            activeClass: 'active',
                            opener: '.as-opener',
                            slider: '.as-nav-slide',
                            animSpeed: 400,
                            hideOnClickOutside: true,
                            effect: 'slide'
                        });
                    },
                    off() {
                        window.jQuery('.as-footer-nav').openClose('destroy');
                    }
                }
            });
            clearInterval(interval);
        }
    }, 1000);
}

export function initMobileHeaderNavOpenClose() {
    let interval = setInterval(() => {
        if (window === undefined || window.jQuery === undefined || window.ResponsiveHelper === undefined || window.jQuery.fn === undefined || window.jQuery.fn.openClose === undefined) {
            // browser code
            return false;
        }
        const ResponsiveHelper = window.ResponsiveHelper;
        if (window.jQuery('.as-account-block').length > 0) {
            window.jQuery('.as-account-block').openClose({
                activeClass: 'active',
                opener: '.as-opener',
                slider: '.as-user-list',
                animSpeed: 400,
                hideOnClickOutside: true
            });
            ResponsiveHelper.addRange({
                '1024..': {
                    on() {
                        window.jQuery('.as-nav-item').openClose({
                            activeClass: 'as-hover',
                            opener: '.as-opener',
                            slider: '.as-dropdown',
                            animSpeed: 400,
                            hideOnClickOutside: true,
                            event: 'hover',
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-nav-item').openClose('destroy');
                    }
                }
            });

            ResponsiveHelper.addRange({
                '..1023': {
                    on() {
                        window.jQuery('.as-nav-item').openClose({
                            activeClass: 'as-selected',
                            opener: '.as-opener',
                            slider: '.as-dropdown',
                            animSpeed: 400,
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-nav-item').openClose('destroy');
                    }
                }
            });

            ResponsiveHelper.addRange({
                '1024..': {
                    on() {
                        window.jQuery('.as-sub-nav-item').openClose({
                            activeClass: 'as-hover',
                            opener: '.as-sub-opener',
                            slider: '.as-sub-dropdown',
                            animSpeed: 400,
                            hideOnClickOutside: true,
                            event: 'hover',
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-sub-nav-item').openClose('destroy');
                    }
                }
            });

            ResponsiveHelper.addRange({
                '..1023': {
                    on() {
                        window.jQuery('.as-sub-nav-item').openClose({
                            activeClass: 'as-selected',
                            opener: '.as-sub-opener',
                            slider: '.as-sub-dropdown',
                            animSpeed: 400,
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-sub-nav-item').openClose('destroy');
                    }
                }
            });

            ResponsiveHelper.addRange({
                '1024..': {
                    on() {
                        window.jQuery('.as-sub-sub-nav-item').openClose({
                            activeClass: 'as-hover',
                            opener: '.as-sub-sub-opener',
                            slider: '.as-sub-sub-dropdown',
                            animSpeed: 400,
                            hideOnClickOutside: true,
                            event: 'hover',
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-sub-sub-nav-item').openClose('destroy');
                    }
                }
            });

            ResponsiveHelper.addRange({
                '..1023': {
                    on() {
                        window.jQuery('.as-sub-sub-nav-item').openClose({
                            activeClass: 'as-selected',
                            opener: '.as-sub-sub-opener',
                            slider: '.as-sub-sub-dropdown',
                            animSpeed: 400,
                            effect: 'none'
                        });
                    },
                    off() {
                        window.jQuery('.as-sub-sub-nav-item').openClose('destroy');
                    }
                }
            });

            window.jQuery('.as-sub-opener, .as-sub-sub-opener').focus((event: any) => {
                window.jQuery(event.target).parent().addClass('as-hover').siblings().removeClass('as-hover');
            });

            window.jQuery('.as-nav>li>a').focus((event: any) => {
                window.jQuery(event.target).parent().addClass('as-hover').siblings().removeClass('as-hover');
                window.jQuery('.as-sub-opener, .as-sub-sub-opener').parent().addClass('as-hover').siblings().removeClass('as-hover');
            });


            window.jQuery('.as-nav li:last-child>a').blur((event: any) => {
                window.jQuery(event.target).parent().removeClass('as-hover');
            });

            window.jQuery(document).click(function (e: any) {
                const navLi = window.jQuery('.as-nav>li');
                if (window.jQuery(e.target).closest(navLi).length) { return; }
                window.jQuery('.as-nav>li').removeClass('as-hover');
            });
            clearInterval(interval);
        }

    }, 1000);
}
